// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Header-cls1___71568b51c1b74550427{/*!*/}.Header-cls2___0ca8acc70eb396aa0df{display:flex;align-items:center;flex-wrap:nowrap;color:#223}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Header-cls1___71568b51c1b74550427",
	"cls2": "Header-cls2___0ca8acc70eb396aa0df Header-cls1___71568b51c1b74550427"
};
export default ___CSS_LOADER_EXPORT___;
